import styled from 'styled-components/macro'

export const AuditsDropdownContainer = styled.div`
  > div.dropdown-menu {
    max-height: 300px;
  }
`
